import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { ZipCountyStateStructure } from 'src/app/angular-elements/shared/interfaces/zipCountyStateStructure.interface';
import { MatDialog } from '@angular/material/dialog';
import { ZipCountyModalComponent } from '../../../demographics/zip-county-modal/zip-county-modal.component';
@Component({
    selector: 'app-rrd-link',
    templateUrl: './rrd-link.component.html',
    styleUrls: ['./rrd-link.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false
})
export class RrdLinkComponent implements OnInit {
  @Input() formularyName: string;
  @Input() productName: string;
  @Input() year: string;

  aspName: string = environment.configs.aspName;
  rrdLink: string = environment.external.vendors.rrdLink;

  constructor(
    private reducerUtilityService: ReducerUtilityService,
    private matDialog: MatDialog,
  ) { }

  ngOnInit() {

  }

  goToRRD() {
    const zipcountyState: ZipCountyStateStructure = this.reducerUtilityService.getState('ZipCounty');
    let zipCode = '';
    let county = '';
    if (zipcountyState) {
      if (!zipcountyState.zipCode) {
        this.matDialog.open(ZipCountyModalComponent, { disableClose: true });
      } else {
        zipCode = zipcountyState.zipCode;
        county = zipcountyState.county && zipcountyState.county.county;
        let finalProdName = this.formularyName;
        let linkType = 'CreateFormulary';
        if (this.productName) {
          finalProdName = this.productName;
          linkType = 'CreateEOC';
        }
        const link = `/${this.aspName}/PortalAPI/${linkType}?Zip=${zipCode}&County=${county}&ProductName=${finalProdName}&Year=${this.year}`;
        const finalUrl = `${this.rrdLink}${link}`;
        window.open(finalUrl, '_blank');
      }
    }
  }
}
